import { Component, computed, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { fb } from '../../../../modules/shared/shared.global-service';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../kit/action-buttons/action-buttons.component';
import { PrintDailyRecordDialogStore } from './print-daily-record-dialog.store';
import { DateInputComponent } from '../../../kit/input/date-input/date-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ServicePatternType } from '@libs/types/src/services/enum/service-pattern-type.enum';
import { ServicePatternDocumentUsageEnum } from '@libs/types/src/services/enum/service-pattern-document-usage.enum';
import { ServicePatternObject } from '@libs/types/src/services/object-type/service/service-pattern.object';
import { CheckInputComponent } from '../../../kit/input/check-input/check-input.component';
import { SelectInputComponent } from '../../../kit/input/select-input/select-input.component';

@Component({
    selector: 'app-print-daily-record-dialog',
    templateUrl: 'print-daily-record-dialog.component.html',
    providers: [PrintDailyRecordDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        DateInputComponent,
        TranslatePipe,
        CheckInputComponent,
        SelectInputComponent,
    ],
})
export class PrintDailyRecordDialogComponent extends BaseDialogComponent {

    public store = inject(PrintDailyRecordDialogStore);

    protected form = fb.group({
        archive: fb.control<boolean>(true),
        headerId: fb.control<number | null>(null),
        footerId: fb.control<number | null>(null),
        onlyMy: fb.control<boolean>(false),
        date: fb.control<Date[]>([]),
    });

    protected loading = false;

    serviceId = computed(() => this.store.globalGlobalStore.loggedUserStore.selectedServiceId());
    headers = computed(() => this.store.data.getServicePatterns()?.items?.filter((item: ServicePatternObject) => item.usage === ServicePatternDocumentUsageEnum.header) ?? []);
    footers = computed(() => this.store.data.getServicePatterns()?.items?.filter((item: ServicePatternObject) => item.usage === ServicePatternDocumentUsageEnum.footer) ?? []);

    constructor() {
        super();

        effect(() => {

            if (!this.serviceId()) return;

            this.store.api.getServicePatterns({
                filter: [
                    [{ column: 'serviceId', value: [String(this.serviceId())], operator: 'EQ' }],
                    [{ column: 'type', value: [ServicePatternType.DOCUMENT], operator: 'EQ' }],
                ],
            });
        });
    }

    public override async save() {
        this.loading = true;

        this.dialogRef.close({
            archive: this.form.value.archive,
            footerId: this.form.value.footerId ?? null,
            headerId: this.form.value.headerId ?? null,
            serviceId: this.serviceId(),
            onlyMy: this.form.value.onlyMy,
            dateFrom: (this.form.value.date as Date[])?.length > 1 ? (this.form.value.date as Date[])[0].toISOString() : null,
            dateTo: (this.form.value.date as Date[])?.length > 1 ? (this.form.value.date as Date[])[1].toISOString() : null,
        });
    }

}
